<!-- PAGE TITLE
        ================================================== -->
<section class="bg-light-red page-title-section top-position1 bg-img cover-background left-overlay-secondary">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <div class="position-relative">
                        <h1>Red Monk Wellness – Expert Profiles </h1>
                        <p>Meet the minds redefining personalized IV Therapy and performance wellness in India.
                        </p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>


<!-- Kanishka Jain Profile
        ================================================== -->

<section class="bg-light-color">
    <div class="container">

        <div class="row">
            <div class="col-lg-3 wow fadeInUp" data-wow-delay="200ms">
                <div class="card card-style-07 border-0 bg-transparent">
                    <div class="image ">
                        <a href="#"><img src="/assets/images/Dr-Kanishka-Jain-rhinomight.jpg"
                                alt="Dr. Kanishka Jain Rhinomight" /></a>
                    </div>
                </div>
            </div>
            <div class="col-lg-9 ps-lg-5 mt-5 mt-lg-0 wow fadeInUp" data-wow-delay="400ms">
                <div class="section-title left mb-3">
                    <!-- <span class="sm-title">RhinoMight </span> -->
                    <h2 class="display-16 lh-1 mb-2">Dr. Kanishka Jain</h2>
                    <p class="para">Co-Founder of RhinoMight</p>
                    <div class="line"></div>
                </div>

                <div class="">
                    <!-- <h5 class="mb-2">From Homemaker to Wellness Expert-</h5> -->
                    <ul class="list-unstyled list-style01 mb-0">
                        <li>Specialist in Sports Medicine & Recovery Science.</li>
                        <li>Works extensively with athletes, HNIs, and performers.</li>
                    </ul>
                    <!-- <p class="mb-2">- Specialist in Functional & Regenerative Medicine.</p> -->

                </div>

                <div class="mt-1-9">
                    <h5 class="mb-2">Vision - </h5>
                    <p class="mb-2">- Bringing precision-based, medically supervised recovery to India's
                        wellness ecosystem</p>

                </div>



                <div class="mb-3 mt-3 pb-0 wow fadeInUp" data-wow-delay="200ms">
                    <h5 class="mb-2">Sports & Regenerative Medicine Physician </h5>

                    <p class="mb-4">Dr. Kanishka Jain is a leading expert in regenerative and sports science,
                        recognized for his evidence-based approach to IV nutrient therapy, inflammation control,
                        and long-term cellular health. At Red Monk Wellness, he oversees the medical protocols
                        behind every IV drip, ensuring each treatment is safe, precise, and clinically
                        validated.</p>

                    <p class="mb-4">His focus on functional recovery and metabolic optimization transforms IV
                        Therapy from a simple hydration service into a science-backed wellness solution that
                        supports endurance, detoxification, and performance longevity. Dr. Kanishka’s medical
                        oversight ensures that every vitamin infusion is customized to enhance vitality,
                        balance, and immune function.</p>

                    <p class="mb-4">“Wellness should be proactive—not reactive. IV therapy allows us to nourish
                        the body before it breaks down.” — Dr. Kanishka Jain</p>

                </div>




            </div>



            <div class="col-lg-12 mt-4 d-none wow fadeInUp" data-wow-delay="400ms">

                <div class="mb-0 pb-0 border-top border-0 wow fadeInUp" data-wow-delay="200ms">
                    <h5 class="mb-2">Founding Red Monk Wellness Pvt. Ltd.</h5>

                    <p class="mb-4">This was the very challenge that Mandavi Sanjay Mishra chose to embrace. She
                        launched her wellness enterprise from the ground up- starting with a powerful vision but
                        minimal resources. Her biggest strengths were her persistence, her family’s unwavering
                        encouragement, and the belief of her doctors who knew she could not only enter the
                        market but redefine what wellness means for modern India.</p>

                </div>


                <div class="mb-0 pb-0 border-top border-0 wow fadeInUp" data-wow-delay="200ms">

                    <p class="mb-4">Mandavi’s mission is driven by a purpose deeper than profit. "Working for
                        a cause brings a unique level of satisfaction," she explains. "While this is undoubtedly
                        a serious business, the hope of helping people stay healthy and feel beautifully
                        confident is a powerful motivation in itself."</p>

                    <p class="mb-4">Mandavi Mishra built her business from a scratch. Armed with little more
                        than the encouragement of her family and the faith of her doctors, she took on the
                        challenge of succeeding in the competitive wellness industry. "Working for a cause
                        brings a unique level of satisfaction," says Mandavi.</p>

                    <p class="mb-4">Explaining the process of treating patients Mandavi said that In the
                        relentless pursuit of optimal health, waiting for the digestive system to process
                        nutrients, one can feel like a bottleneck. Intravenous (IV) therapy, a method once
                        confined to hospital wards, has emerged as a premier tool in proactive wellness,
                        offering a decisive advantage: direct-to-bloodstream delivery. When administered by a
                        qualified doctor, this therapy transcends trendy "drip bar" offerings to become a
                        precise, safe, and highly effective modality for enhancing general well-being.</p>


                    <p class="mb-4">The core principle behind IV therapy's effectiveness is 100%
                        bioavailability. Unlike oral supplements, which are subject to the unpredictable nature
                        of the gastrointestinal tract, IV infusions deliver vitamins, minerals, antioxidants,
                        and amino acids directly to the body cells. This immediate and complete absorption is
                        particularly crucial for individuals with digestive inefficiencies, high-stress
                        lifestyles, or those recovering from illness, where the body's demand for nutrients is
                        significantly heightened, says Mandavi Mishra. </p>



                </div>


            </div>

        </div>


    </div>
</section>



<!-- Vision
        ================================================== -->
<section class="bg-light-yellow2">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 mb-3 wow fadeInUp" data-wow-delay="100ms">
                <div>
                    <div class="section-title-02 position-relative mb-3">

                        <!-- <span class="sm-title">Portfolio </span> -->
                        <h2 class="position-relative z-index-9 mb-0">Their Vision at Red Monk Wellness</h2>

                    </div>
                    <p class="mb-2">Together, Ashim Matthan and Dr. Kanishka Jain bring the RhinoMight
                        philosophy of precision, performance, and science to Red Monk Wellness, creating India’s
                        most advanced IV Therapy destination. Their combined expertise powers Red Monk’s
                        precision-based IV therapy programs, where real-time diagnostics and personalized
                        formulations help clients achieve rapid recovery, deep hydration, and sustained energy.
                    </p>

                    <p class="mb-2">By merging medical innovation with mindful care, they have positioned Red
                        Monk Wellness as a trusted leader in functional IV therapy, catering to professionals,
                        travelers, athletes, and anyone seeking high-performance wellness.</p>

                </div>
            </div>
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="200ms">
                <div class="text-center image-hover">
                    <img src="/assets/images/vision.jpg" class="rounded" alt="Vision" />
                </div>
            </div>
        </div>

    </div>
</section>